import Seo from "@/components/site/Seo";
import EnquiryForm from "@/components/site/EnquiryForm";
import { Notice, PageHero } from "@/components/site/kit";
import { PLAYER_FIELDS } from "@/lib/forms";

export default function PlayerRegister() {
  return (
    <>
      <Seo title="Player Registration" description="Register your interest to play in the Telangana–Andhra T10 League. Registration does not guarantee selection." />
      <PageHero testid="register-hero" eyebrow="Player Registration" title="Register Your Interest" image="/images/street-bowler.jpg">
        Tell us about your game. Our team will contact registered players regarding eligibility, trials and next steps.
      </PageHero>
      <section className="container-x grid gap-10 py-16 lg:grid-cols-[1fr_320px]">
        <EnquiryForm
          testid="player-form"
          fields={PLAYER_FIELDS}
          endpoint="/forms/player"
          submitLabel="Submit Registration"
          consentText="I confirm the information provided is accurate, and I consent to CGN Sports storing and processing my personal data and photograph for player registration, eligibility review and selection communications, in line with the Privacy Policy. I understand registration does not guarantee selection."
          success="Thank you for registering your interest in the Telangana–Andhra T10 League. Our team will contact you regarding the next steps."
        />
        <aside className="space-y-4">
          <Notice testid="register-no-guarantee">Registration does not guarantee selection, trial invitation or a place in any squad.</Notice>
          <div className="rounded-md border border-white/10 bg-[#112240] p-6 text-sm text-slate-300">
            <h2 className="font-display text-xl uppercase text-white">Your data is private</h2>
            <p className="mt-2">Personal details, contact information and documents are visible only to authorised league administrators. Only approved player profile information (name, role and playing style) is ever displayed publicly.</p>
          </div>
        </aside>
      </section>
    </>
  );
}
